module.exports = __webpack_public_path__ + "static/media/sample_intro_3.ece34bc3.jpg";